import styled from "styled-components";
import { Menu as AntdMenu, Flex, Typography } from "antd";

interface CardEmojiProps {
  $isCaixaTheme?: boolean;
}

export const UserContainer = styled(Flex)`
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const Menu = styled(AntdMenu)`
  background-color: ${({ theme }) => theme.token.colorPrimary};
  border-bottom: none;
  display: flex;
  align-items: center;

  .ant-menu-item,
  .ant-menu-submenu-title {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .ant-menu-submenu-arrow {
    color: #fff;
  }
`;

export const MenuText = styled(Typography.Text)`
  color: #fff;
  white-space: nowrap;
  margin: 0 !important;
`;

export const UserIconWrapper = styled.div<CardEmojiProps>`
  width: 28px;
  height: 28px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${({ theme, $isCaixaTheme }) =>
    $isCaixaTheme ? "#F39200" : theme.token.colorPrimary};

  .anticon {
    color: #fff;
    font-size: 14px;
  }
`;
